import React from 'react';
import { XIcon } from '@fronton/icons-react';
import { Button } from '../button';
import { Modal } from '../modal';
import { closeIcon, modalMediaCard, modalMediaCardContent } from './modal-media-card-styles';

type ModalMediaCardProps = {
  onClose: () => void;
  show: boolean;
  children: React.ReactNode;
}

export const ModalMediaCard = ({ children, show, onClose }: ModalMediaCardProps) => (
  <Modal
    className={modalMediaCard}
    closeButton={false}
    onClose={onClose}
    show={show}
    size="l"
    variant="curtain"
  >
    <Button adaptive={false} size="s" className={closeIcon} iconOnly label="Close" rounded onClick={onClose}>
      <XIcon type='outline' size='m' color='text-invert'/>
    </Button>
    <div className={modalMediaCardContent}>
      {children}
    </div>
  </Modal>
);
